import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from '../../api/client.js';

const ITEMS = [
  { key: 'dashboard', to: '/admin/dashboard', icon: 'speed', label: 'Dashboard' },
  { key: 'portfolio', to: '/admin/portfolio', icon: 'photo_library', label: 'Portofolio' },
  { key: 'layanan', to: '/admin/layanan', icon: 'view_sidebar', label: 'Layanan' },
  { key: 'settings', to: '/admin/settings', icon: 'settings', label: 'Setelan' },
];

export default function AdminBottomNav() {
  const { pathname } = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    api.get('/admin/dashboard').then(({ data }) => setUnread(data.stats?.kontak_unread || 0)).catch(() => {});
  }, [pathname]);

  const isActive = (to) => pathname === to || pathname.startsWith(to + '/');
  const kontakActive = pathname.startsWith('/admin/kontak');

  return (
    <>
      <div className="md:hidden fixed bottom-4 left-4 right-4 z-50 flex items-center gap-3">
        <nav className="flex-1 flex items-center justify-around px-2 py-2 rounded-full bg-white/90 dark:bg-neutral-900/90 backdrop-blur-md border border-white/50 dark:border-neutral-700/60 shadow-lg">
          {ITEMS.map((item) => {
            const active = isActive(item.to);
            return (
              <Link key={item.key} to={item.to} className={`abn-item ${active ? 'abn-active' : ''}`}>
                <span className="abn-pill">
                  <span className="abn-icon material-symbols-outlined">{item.icon}</span>
                  <span className="abn-label">{item.label}</span>
                </span>
              </Link>
            );
          })}
        </nav>

        <Link
          to="/admin/kontak"
          className={`abn-cta relative flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-2xl bg-[var(--accent)] dark:bg-[var(--accent-hover)] text-white shadow-[0_8px_24px_color-mix(in_oklab,_var(--accent)_45%,_transparent)] ${kontakActive ? 'abn-active' : ''}`}
          title="Pesan Masuk"
        >
          {unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-red-500 text-white text-[9px] font-bold leading-none ring-2 ring-white dark:ring-neutral-900 pointer-events-none">
              {unread > 99 ? '99+' : unread}
            </span>
          )}
          <span className="abn-cta-icon material-symbols-outlined text-2xl leading-none">mail</span>
        </Link>
      </div>
      <div className="md:hidden h-24" />
    </>
  );
}
